import "./Loader.scss";

export default function Loader() {
  return (
    <div className="loader">
      <div className="loader__typewriter">
        <h1 className="loader__text">
          Welcome{window.innerWidth < 696 ? "" : ` to My Portfolio`}!
        </h1>
      </div>
    </div>
  );
}
